module.exports = __webpack_public_path__ + "img/logo-dark.cbd5733c.png";